module.exports = __webpack_public_path__ + "img/Logo-half-grey.651ea29a.svg";